import { Search, MessageSquare } from 'lucide-react';
import WhatsAppStatusCheck from './WhatsAppStatusCheck';
import { formatChatTime } from '../lib/whatsappTime';

// Extraído de WhatsAppPanel.jsx (02.3-client.md paso b) -- barra de búsqueda + lista de chats,
// mostrada cuando `status === 'connected'` y no hay chat activo. Estilos inline verbatim.
export default function WhatsAppChatList({ chats, searchQuery, onSearchChange, onSelectChat }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Search thread */}
      <div style={{ padding: 'var(--space-3) var(--space-4)', background: '#111113', position: 'sticky', top: 0, zIndex: 10 }}>
        <div style={{ position: 'relative', width: '100%' }}>
          <Search size={14} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.3)' }} />
          <input
            type="text"
            placeholder="Buscar chat por nombre..."
            aria-label="Buscar chat por nombre"
            value={searchQuery}
            onChange={e => onSearchChange(e.target.value)}
            style={{
              width: '100%',
              background: '#1c1c1e',
              border: '1px solid rgba(255,255,255,0.06)',
              borderRadius: 'var(--radius-md)',
              padding: 'var(--space-2) var(--space-3) var(--space-2) var(--space-8)',
              fontSize: '12px',
              color: '#fff',
              outline: 'none',
              transition: 'border-color .2s'
            }}
            onFocus={e => e.currentTarget.style.borderColor = 'rgba(249, 115, 22, 0.5)'}
            onBlur={e => e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.06)'}
          />
        </div>
      </div>

      {/* List */}
      {chats.length === 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-12) var(--space-5)', color: 'rgba(255,255,255,0.3)', fontSize: '13px' }}>
          <MessageSquare size={24} style={{ marginBottom: 'var(--space-2)', opacity: 0.5 }} />
          No se encontraron conversaciones
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {chats.map(chat => (
            <div
              key={chat.chat_jid}
              onClick={() => onSelectChat(chat)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--space-3)',
                padding: 'var(--space-3) var(--space-4)',
                borderBottom: '1px solid rgba(255, 255, 255, 0.03)',
                cursor: 'pointer',
                transition: 'background .2s'
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              {/* Avatar */}
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: '#2c2c2e',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                color: '#fff',
                fontSize: '15px',
                flexShrink: 0
              }}>
                {chat.avatar_url && chat.avatar_url !== 'no_avatar' ? (
                  <img src={chat.avatar_url} alt="" loading="lazy" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
                ) : (
                  (chat.name || '?')[0].toUpperCase()
                )}
              </div>

              {/* Meta info */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 'var(--space-1)' }}>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: '#f3f4f6', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '170px' }}>
                    {chat.name || 'Chat'}
                  </span>
                  <span style={{ fontSize: '10px', color: 'rgba(255,255,255,0.35)' }}>
                    {formatChatTime(chat.last_message_timestamp)}
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.45)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '200px' }}>
                    {chat.last_message_text || '—'}
                  </span>

                  <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-1)' }}>
                    {chat.last_message_status && chat.unread_count === 0 && (
                      <WhatsAppStatusCheck status={chat.last_message_status} />
                    )}
                    {chat.unread_count > 0 && (
                      <span style={{
                        background: '#25d366',
                        color: '#fff',
                        borderRadius: '50%',
                        minWidth: '18px',
                        height: '18px',
                        padding: '2px var(--space-1)',
                        fontSize: '10px',
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        lineHeight: 1
                      }}>
                        {chat.unread_count}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
